import React, { useEffect, useState } from 'react';
import {
    DashboardOutlined,
    DollarCircleOutlined,
    PoweroffOutlined,
    RetweetOutlined,
    ExperimentOutlined,
    CopyOutlined,
    SnippetsOutlined,
    FlagOutlined,
    UsergroupAddOutlined,
    MessageOutlined,
    MoneyCollectOutlined,
    RedEnvelopeOutlined,
    AccountBookOutlined,
    StarOutlined,
    StarFilled,
    SearchOutlined,
} from '@ant-design/icons';

import { useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu, Drawer, message, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { clearFilter, loyaltyAdminCheck } from '../reducer/userReducer';
import { saveFavoriteMenus, fetchFavoriteMenus } from '../reducer/reportsReducer';
import { useTranslation } from 'react-i18next';
const { Sider } = Layout;

const SideBarComponent = ({ collapsed, setCollapsed, showDrawer, setShowDrawer, devSideBars }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const lang = localStorage.getItem('laundro-language');

    const currentPath = window.location.pathname;

    const { loyaltyToken, error, operator, staff, distributor, client } = useSelector((state) => state.user);
    const [searchText, setSearchText] = useState('');
    const { favoriteMenus } = useSelector((state) => state.reports);

    const stateData = location.state;

    // console.log('staff', staff);
    function getItem(label, key, icon, children) {
        return {
            label,
            key,
            icon,
            children,
        };
    }

    const toggleFavorite = (e, menuKey) => {
        e.domEvent.stopPropagation();
        const currentFavorites = favoriteMenus || [];
        const isFavorited = currentFavorites.includes(menuKey);
        
        const updatedFavorites = isFavorited
            ? currentFavorites.filter(key => key !== menuKey)
            : [...currentFavorites, menuKey];
        
        dispatch(saveFavoriteMenus(updatedFavorites));
    };

    const octopusUrlBrowsable = [
        getItem('Cycle Record', '/transactions_record', null, null),
        getItem('Epayment Record', '/epayment_record', null, null),
        // getItem('Overall Epayment Record', '/overall_epayment_record', null, null),
        getItem('Terminal Record', '/terminal_record', null, null),
        getItem('Manual Pay Record', '/manualPay_record', null, null),
        getItem('Bill Record', '/bill_record', null, null),
        getItem('Vending Record', '/vending_record', null, null),
        getItem('Drop And Go Record', '/dng_record', null, null),
        getItem('Subscription Record', '/subscription_record', null, null),
        getItem('Kiosk Record', '/kiosk_record', null, null),
    ];

    const octopusUrlSpecial = [
        // getItem('Sales Summary', '/sales_summary', null, null),
        getItem('Overall Sales Summary', '/sales/overall', null, null),
        getItem('Hourly Sales Trend Report', '/hourly_sales_transaction', null, null),
        // getItem('Sales by Machine Type', '/salesByMachineType', null, null),
        getItem('Error Code Record', '/errorcode_record', null, null),
        // getItem('Machines Sales Transactions', '/sales_transaction_record', null, null),
        getItem('Weekly Report', '/weekly/report', null, null),
        getItem('Costing Report', '/costing_record', null, null),
        // getItem('Machine Efficiency', '/machine/efficiency', null, null),
        getItem('System Error Report', '/systemErrorReport', null, null),
        // getItem('Profit And Loss Record', '/profitloss_record', null, null),
        getItem('Unresolve Report', '/unresolve_record', null, null),
    ];

    const cleanProUrlBrowsable = [
        getItem('Cycle Record', '/transactions_record', null, null),
        getItem('Epayment Record', '/epayment_record', null, null),
        // getItem('Overall Epayment Record', '/overall_epayment_record', null, null),
        getItem('Terminal Record', '/terminal_record', null, null),
        getItem('Manual Pay Record', '/manualPay_record', null, null),
        getItem('Bill Record', '/bill_record', null, null),
        getItem('Vending Record', '/vending_record', null, null),
        getItem('Drop And Go Record', '/dng_record', null, null),
        getItem('Subscription Record', '/subscription_record', null, null),
        getItem('Kiosk Record', '/kiosk_record', null, null),
        getItem('Import Management', '/importData', null, null),
    ];

    const cleanProUrlSpecial = [
        // getItem('Sales Summary', '/sales_summary', null, null),
        getItem('Overall Sales Summary', '/sales/overall', null, null),
        getItem('Hourly Sales Trend Report', '/hourly_sales_transaction', null, null),
        // getItem('Sales by Machine Type', '/salesByMachineType', null, null),
        // getItem('Machines Sales Transactions', '/sales_transaction_record', null, null),
        getItem('Weekly Report', '/weekly/report', null, null),
        getItem('Costing Report', '/costing_record', null, null),
        // getItem('Machine Efficiency', '/machine/efficiency', null, null),
        getItem('System Error Report', '/systemErrorReport', null, null),
        getItem('Chemical Stock Report', '/inventory/chemicalstock', null, null),
        getItem('Chemical Stock Daily Report', '/inventory/chemicalbalancereport', null, null),
        // getItem('Profit And Loss Record', '/profitloss_record', null, null),
        getItem('Unresolve Report', '/unresolve_record', null, null),
    ];


    const [items, setItems] = useState([]);
    const [openKeys, setOpenKeys] = useState([]);

    const baseItems = [
        getItem('Home', '/mainDashboard', <DashboardOutlined />, null),
        // getItem('Investor Dashboard', '/mainDashboardv2', <DashboardOutlined />, null),
        // getItem('Bill Acceptor Dashboard', '/billacceptordashboard', <DashboardOutlined />, null),
        // getItem('Offline Dashboard', '/offline_dashboard', <DashboardOutlined />, null),
        // getItem('Sales Performance', `/annualOverview`, <DollarCircleOutlined />, null),
        // getItem('Bill Sales Performance', `/billSalesPerformance`, <DollarCircleOutlined />, null),
        // getItem('Machine Utilization', '/machineUtilization', <RetweetOutlined />, null),
        getItem('Remote Activation', '/remoteActivation', <PoweroffOutlined />, null),
        getItem('Loyalty Admin', '/redirectLoyaltyAdmin', <UsergroupAddOutlined />, null),
        getItem('Review Dashboard', `/reviewDashboard`, <FlagOutlined />, null),
        getItem('Dashboard', 'sub11', <SnippetsOutlined />, [
            getItem('Investor Dashboard', '/mainDashboardv2', <DashboardOutlined />, null),
            getItem('Bill Acceptor Dashboard', '/billacceptordashboard', <DashboardOutlined />, null),
            getItem('Offline Dashboard', '/offline_dashboard', <DashboardOutlined />, null),
            getItem('Sales Performance', `/annualOverview`, <DollarCircleOutlined />, null),
            getItem('Bill Sales Performance', `/billSalesPerformance`, <DollarCircleOutlined />, null),
            getItem('Machine Utilization', '/machineUtilization', <RetweetOutlined />, null),
            getItem('Utility Monitoring', '/utilityMonitoring', <ExperimentOutlined />),
        ]),
        getItem(
            'Browsable Report',
            'sub6',
            <CopyOutlined />,
            window.location.href.includes('octopus') ? octopusUrlBrowsable : cleanProUrlBrowsable
        ),
        getItem(
            'Special Report',
            'sub10',
            <SnippetsOutlined />,
            window.location.href.includes('octopus') ? octopusUrlSpecial : cleanProUrlSpecial
        ),
        getItem('Settings', 'sub7', <SnippetsOutlined />, [
            getItem('Price Setting', '/priceList', null, null),
            getItem('Promotion Setting', '/promotion', null, null),
            getItem('Drop Service', '/droppriceList', null, null),
            getItem('Chemical Stock Setting', '/priceList2', null, null),
            getItem('Costing Setting', '/costingList', null, null),
            getItem('Sales Setting', '/salesList', null, null),
            getItem('Machine Settings', '/machineSettings', null, null),
            getItem('Profit & Loss Setting', '/profit&loss', null, null),
            getItem('Machine Logging', '/machineLog', null, null),
        ]),
        getItem('Collection', 'sub8', <RedEnvelopeOutlined />, [
            getItem('Collection Entry', '/coin/collection', <MoneyCollectOutlined />, null),
            getItem('Coin Collection Report', '/coin/collection/outlet', null, null),
            getItem('Coin Collection Detail', '/coin/collection/machine', null, null),
            getItem('Bill Collection Report', '/collection/bill', null, null),
            getItem('Coinbox Management', '/inventory/management', null, null),
        ]),

        // getItem('Inventory Management', '/inventory/management', <AccountBookOutlined />, [
        //     // getItem('Inventory Management', '/inventory/management', null, null),
        //     getItem('Costing Log Update', '/costingLog', null, null),
        //     getItem('Sales Log Update', '/salesLog', null, null),
        //     getItem('Input Stock', '/inventory/inputstock', null, null),
        // ]),

        getItem('e-Invoicing', 'sub9', <RedEnvelopeOutlined />, [
            getItem('Einvoice Report', '/invoice/report', <DashboardOutlined />, null),
            getItem('Einvoice Consolidation', '/invoice/consolidate', <DashboardOutlined />, null),
            getItem('Einvoice Validation', '/invoice/validation', <DashboardOutlined />, null),
            getItem('Einvoice Epayment Validation', '/invoice/epayvalidation', <DashboardOutlined />, null),
            getItem('Einvoice Package Validation', '/invoice/packagevalidation', <DashboardOutlined />, null)
        ]),
    ];

    const clientItems = [
        // getItem('Home', '/mainDashboard', <DashboardOutlined />, null),
        getItem('Remote Activation', '/remoteActivation', <PoweroffOutlined />, null),
        // getItem('Dashboard', 'sub11', <SnippetsOutlined />, [
        //     getItem('Investor Dashboard', '/mainDashboardv2', <DashboardOutlined />, null),
        //     getItem('Bill Acceptor Dashboard', '/billacceptordashboard', <DashboardOutlined />, null),
        //     getItem('Offline Dashboard', '/offline_dashboard', <DashboardOutlined />, null),
        //     getItem('Sales Performance', `/annualOverview`, <DollarCircleOutlined />, null),
        //     getItem('Bill Sales Performance', `/billSalesPerformance`, <DollarCircleOutlined />, null),
        // ]),
    ];

    const redirectToLoyaltyAdmin = () => {
        dispatch(loyaltyAdminCheck());
    };

    useEffect(() => {
        if (!client) dispatch(fetchFavoriteMenus());
    }, [dispatch, client]);

    useEffect(() => {
        if (error) {
            message.error(error.en);
        }
    }, [error]);

    useEffect(() => {
        if (loyaltyToken) {
            const redirectUrl = `${loyaltyToken}&redirectUrl=${window.location.href}&userType=${stateData.userType}&language=${lang}`;
            window.location.href = redirectUrl;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loyaltyToken]);

    useEffect(() => {
        // Client users are restricted by role, not permission entries
        if (client) {
            setItems(clientItems);
            return;
        }
        if (operator || distributor || staff) {
            const getUser = () => {
                if (operator) {
                    return operator;
                } else if (staff) {
                    return staff;
                } else return distributor;
            };

            if (getUser().permissions && getUser().permissions.length) {
                const availablePermissions = getUser()
                    .permissions.filter((permission) => permission.type === 'laundro' && permission.permission)
                    .map((permission) => permission.title);

                let newItems = [];
                const currentFavorites = favoriteMenus || [];

                for (let i = 0; i < baseItems.length; i++) {
                    const { label, children } = baseItems[i];
                    if (children && children.length) {
                        let newChildren = [];
                        for (let j = 0; j < children.length; j++) {
                            if (availablePermissions.includes(children[j].label)) newChildren.push(children[j]);
                        }
                        if (newChildren.length)
                            newItems.push({
                                ...baseItems[i],
                                children: newChildren,
                            });
                    } else {
                        if (availablePermissions.includes(label)) newItems.push(baseItems[i]);
                    }
                }

                // Add favorites submenu at the top if there are favorites
                if (currentFavorites.length > 0) {
                    const favoriteItems = [];
                    const findFavoriteItem = (itemsList) => {
                        itemsList.forEach(item => {
                            if (currentFavorites.includes(item.key)) {
                                favoriteItems.push(item);
                            }
                            if (item.children) {
                                findFavoriteItem(item.children);
                            }
                        });
                    };
                    findFavoriteItem(newItems);
                    
                    if (favoriteItems.length > 0) {
                        const favoritesSubmenu = getItem('Favorites', 'favorites-submenu', <StarFilled />, favoriteItems);
                        newItems.unshift(favoritesSubmenu);
                        
                        // Set open keys to include favorites submenu so it's always expanded
                        setOpenKeys(['favorites-submenu']);
                    }
                } else {
                    // Clear open keys if no favorites
                    setOpenKeys([]);
                }

                setItems(newItems);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operator, distributor, staff, client, favoriteMenus]);

    // console.log(items)

    // { state: { userType: 'operator' } }

    // console.log('loyaltyToken', loyaltyToken);
    // console.log('stateData', stateData);

    const filteredItems = items.filter((item) => {
        if (
            item.label.toLowerCase().includes(searchText.toLowerCase())
        ) {
            return true;
        }

        if (item.children) {
            return item.children.some((child) =>
                child.label.toLowerCase().includes(searchText.toLowerCase())
            );
        }

        return false;
    }).map((item) => {
        if (!item.children) return item;

        return {
            ...item,
            children: item.children.filter((child) =>
                child.label.toLowerCase().includes(searchText.toLowerCase())
            ),
        };
    });

    const onOpenChange = (keys) => {
        setOpenKeys(keys);
    };

    return (
        <Sider width='250' className='sidebar-sider' trigger={null} collapsible collapsed={collapsed}>
            <div className='sidebar-menu-logo' />

            <div className='d-flex flex-column justify-content-between'>
                <div>
                    <div style={{ padding: '10px' }}>
						<Input
							placeholder="Search menu..."
							prefix={<SearchOutlined />}
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
						/>
					</div>
                    {showDrawer ? (
                        <Drawer
                            headerStyle={{ height: '300px' }}
                            placement='left'
                            width={250}
                            onClose={() => setShowDrawer(false)}
                            open={showDrawer}
                        >
                            <Menu
                                defaultSelectedKeys={[currentPath]}
                                theme='light'
                                mode='inline'
                                openKeys={openKeys}
                                onOpenChange={onOpenChange}
                                items={filteredItems.map((e) => {
                                    const currentFavorites = favoriteMenus || [];
                                    const isFavorited = currentFavorites.includes(e.key);
                                    const StarIcon = isFavorited ? StarFilled : StarOutlined;
                                    
                                    if (e.children) {
                                        return {
                                            ...e,
                                            label: (
                                                <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span>{t(e.label)}</span>
                                                </span>
                                            ),
                                            children: e.children.map((child) => {
                                                const childIsFavorited = currentFavorites.includes(child.key);
                                                const ChildStarIcon = childIsFavorited ? StarFilled : StarOutlined;
                                                return {
                                                    ...child,
                                                    label: (
                                                        <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                            <span>{t(child.label)}</span>
                                                            <ChildStarIcon 
                                                                style={{ fontSize: '14px', color: childIsFavorited ? '#fadb14' : '#d9d9d9' }}
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    event.domEvent = event;
                                                                    toggleFavorite(event, child.key);
                                                                }}
                                                            />
                                                        </span>
                                                    ),
                                                };
                                            }),
                                        };
                                    }
                                    
                                    // Don't show star on favorites submenu itself
                                    if (e.key === 'favorites-submenu') {
                                        return {
                                            ...e,
                                            label: t(e.label),
                                        };
                                    }
                                    
                                    return {
                                        ...e,
                                        label: (
                                            <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                <span>{t(e.label)}</span>
                                                <StarIcon 
                                                    style={{ fontSize: '14px', color: isFavorited ? '#fadb14' : '#d9d9d9' }}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        event.domEvent = event;
                                                        toggleFavorite(event, e.key);
                                                    }}
                                                />
                                            </span>
                                        ),
                                    };
                                })}
                                onClick={(e) => {
                                    setShowDrawer(false);
                                    // console.log('e', e.key)
                                    if (e.key === '/redirectLoyaltyAdmin') {
                                        return redirectToLoyaltyAdmin();
                                    } else {
                                        navigate(e.key, { state: stateData });
                                        dispatch(clearFilter());
                                    }
                                }}
                            />
                        </Drawer>
                    ) : (
                        <Menu
                            defaultSelectedKeys={[currentPath]}
                            theme='light'
                            mode='inline'
                            openKeys={openKeys}
                            onOpenChange={onOpenChange}
                            items={filteredItems.map((e) => {
                                // console.log(e);
                                const currentFavorites = favoriteMenus || [];
                                const isFavorited = currentFavorites.includes(e.key);
                                const StarIcon = isFavorited ? StarFilled : StarOutlined;
                                
                                if (e.children) {
                                    return {
                                        ...e,
                                        label: (
                                            <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span>{t(e.label)}</span>
                                            </span>
                                        ),
                                        children: e.children.map((i) => {
                                            const childIsFavorited = currentFavorites.includes(i.key);
                                            const ChildStarIcon = childIsFavorited ? StarFilled : StarOutlined;
                                            return {
                                                ...i,
                                                label: (
                                                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                        <span>{t(i.label)}</span>
                                                        <ChildStarIcon 
                                                            style={{ fontSize: '14px', color: childIsFavorited ? '#fadb14' : '#d9d9d9' }}
                                                            onClick={(event) => {
                                                                event.stopPropagation();
                                                                event.domEvent = event;
                                                                toggleFavorite(event, i.key);
                                                            }}
                                                        />
                                                    </span>
                                                ),
                                            };
                                        }),
                                    };
                                }
                                
                                // Don't show star on favorites submenu itself
                                if (e.key === 'favorites-submenu') {
                                    return {
                                        ...e,
                                        label: t(e.label),
                                    };
                                }
                                
                                return {
                                    ...e,
                                    label: (
                                        <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                            <span>{t(e.label)}</span>
                                            <StarIcon 
                                                style={{ fontSize: '14px', color: isFavorited ? '#fadb14' : '#d9d9d9' }}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    event.domEvent = event;
                                                    toggleFavorite(event, e.key);
                                                }}
                                            />
                                        </span>
                                    ),
                                };
                            })}
                            onClick={(e) => {
                                if (e.key === '/redirectLoyaltyAdmin') {
                                    return redirectToLoyaltyAdmin();
                                } else {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'Feature',
                                        // eslint-disable-next-line no-useless-escape
                                        'feature': e.key ? e.key.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '') : null,
                                        'user_id': distributor ? distributor.data.username : staff ? staff.data.username : operator ? operator.data.username : null,
                                        'email': distributor ? distributor.data.email : staff ? staff.data.email : operator ? operator.data.email : null,
                                        'role': distributor ? 'Distributor' : staff ? 'Staff' : operator ? 'Operator' : null
                                    })
                                    navigate(e.key, { state: stateData });
                                    dispatch(clearFilter());
                                }
                            }}
                        />
                    )}
                </div>
            </div>
        </Sider>
    );
};

export default SideBarComponent;